// ESM-Huelle um lib/scripts/pos/CLS_CPOSReports.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.

// Strict-Mode-Fix (ESM): implizit zugewiesene Sloppy-Mode-Globals
// modulweit deklarieren (nur ZUGEWIESENE Namen - nur-gelesene wie
// process/lp behalten bewusst ihren vorbestehenden ReferenceError).
var day, found, sql;
function CReports(db) {
    this.db = db;
    this.Reports = ["DAILY", "PRODSELLINGS", "AFIS_Geldschein"];
    //  this.Reports = ["AFIS_Geldschein"];
    POS.Reports = this;
}
/*PRODSELLINGS

SELECT SUM(QTY),SUM(AMOUNT),PROD_ID,GroupText1,GroupText2 from (
SELECT PRODSELLS2.QTY as Qty,PRODSELLS2.PROD_ID as PROD_ID,PRODSELLS2.Text1 as Text1,PRODSELLS2.Text2 as Text2,PRODSELLS2.Amount as Amount,B2.Text1 as GroupText1, B2.Text2 as GroupText2 from (
 SELECT case when PRODSELLS.Foreign_ID<1000000000 then Qty else TotalQty end as Qty,
        case when PRODSELLS.Foreign_ID<1000000000 then PRODSELLS.Foreign_ID else ProdInStraussID end as PROD_ID,
        case when PRODSELLS.Foreign_ID<1000000000 then PRODSELLS.Text1 else ProdInStraussText1 end as Text1,
        case when PRODSELLS.Foreign_ID<1000000000 then PRODSELLS.Text2 else ProdInStraussText2 end as Text2,
        case when PRODSELLS.Foreign_ID<1000000000 then PRODSELLS.Amount else TotalAmount end as Amount from
        (SELECT * from BONE  left join BON on BON.BON_ID=BONE.BON_ID
        left join (SELECT BONE3.Foreign_ID as StraussForeignID,(BONE3.Qty*BONE4.Qty) as TotalQTY,(BONE3.Qty*BONE4.Amount) as TotalAmount,BONE3.Qty as StraussQty,BONE3.Amount as StraussAmount,BONE4.QTY as ProdInStraussQty,BONE4.Amount as ProdInStraussAmount,BONE4.Foreign_ID as ProdInStraussID,BONE4.Text1 as ProdInStraussText1,BONE4.Text2 as ProdInStraussText2 from BONE as BONE3 left join BONE as BONE4 on BONE3.BON_ID=BONE4.BON_ID where BONE3.Type='BFC'and BONE4.Type='POS' and BONE4.Cancelled=0)
                as BONE2 on BONE.Foreign_ID=BONE2.StraussForeignID
                where BONE.Type='POS' and BON.Type='CLS' and BON.Cancelled=0 and BONE.Cancelled=0) as PRODSELLS
    where PRODSELLS.TS>1502318734 and PRODSELLS.TS<1502401534) as PRODSELLS2
    left join BTN as B1 on B1.PROD_ID=PRODSELLS2.PROD_ID
    left join BTN as B2 on B2.BTN_ID=B1.Parent_BTN_ID) as PRODSELLS3
    group by PROD_ID;



/*Umastzberichte:
select substr(DAY,0,8) as Monat,GroupName,Button,sum(Sold) as VerkauftStk,sum(Delivered) as GeliefertStk,sum(SellPrice) as VerkaufGesamt,sum(BuyPrice) as EinkaufGesamt from PRODSELLINGS where Type='SLD' group by GroupName,Monat order by Monat,GroupName;
ohne globalen Rabatt:
///alt
select BONE.BONE_ID,BONE.BON_ID,case when BONE3.BON_ID>0 then BONE4.Qty*BONE2.Qty else BONE2.Qty end as Anzahl,case when BONE3.BON_ID>0 then BONE4.Text1 else BONE2.Text1 end as Produkt,case when BONE3.BON_ID>0 then (-1)*BONE4.Amount*BONE2.Qty*BONE.Qty else BONE.Amount end as Rabattbetrag,BONE.Type as Typ,BONE2.Text1 as Produkt2,BONE2.Qty as Produktanzahl2,BONE2.Amount as VK,BONE.Qty as Rabatt, BONE.Amount as Rabattbetrag2,PROD.VATGroup as Produktgruppe,case when PROD.PROD_ID>0 then PROD.PROD_ID  else BONE2.Foreign_ID end as ProduktID,BONE2.Foreign_ID,BONE.TS,BONE3.BON_ID as StraussBON_ID,BONE4.Text1 as Produkt1,BONE4.Qty as Anzahl1,BONE4.Amount as StraussVK from BONE
left join BON on BON.BON_ID=BONE.BON_ID
left join  BONE as BONE2 on BONE.Reference_BONE_ID=BONE2.BONE_ID
left join (select BON_ID,Foreign_ID from BONE where Foreign_ID>1000000000 and Type='BFC') as BONE3 on BONE2.Foreign_ID= BONE3.Foreign_ID
left join (select Text1,Qty,Amount,BON_ID,Cancelled from BONE where Type='POS') as BONE4 on BONE4.BON_ID=StraussBON_ID and BONE4.Cancelled=0
left join (select * from PROD group by Text1) as PROD on Produkt=PROD.Text1
where  BONE.Type LIKE '%RB' and BON.cancelled=0 and BONE.Cancelled=0 and BONE.Cancelled=0 and BON.Type='CLS' and Typ IS NOT 'GRB';
//alt end
ARB, MRB
select BONE.BONE_ID,BONE.BON_ID,case when BONE3.BON_ID>0 then BONE4.Qty*BONE2.Qty else BONE2.Qty end as Anzahl,case when BONE3.BON_ID>0 then BONE4.Text1 else BONE2.Text1 end as Produkt,case when BONE3.BON_ID>0 then (-1)*BONE4.Amount*BONE2.Qty*BONE.Qty else BONE.Amount end as Rabattbetrag,BONE.Type as Typ,BONE2.Text1 as Produkt2,BONE2.Qty as Produktanzahl2,BONE2.Amount as VK,BONE.Qty as Rabatt, BONE.Amount as Rabattbetrag2,case when BONE2.Foreign_ID<1000000000 then BONE2.Foreign_ID else BONE4.Foreign_ID end as ProduktID,BONE2.Foreign_ID,BONE.TS,BONE3.BON_ID as StraussBON_ID,BONE4.Text1 as Produkt1,BONE4.Qty as Anzahl1,BONE4.Amount as StraussVK from BONE
left join BON on BON.BON_ID=BONE.BON_ID
left join  BONE as BONE2 on BONE.Reference_BONE_ID=BONE2.BONE_ID
left join (select BON_ID,Foreign_ID from BONE where Foreign_ID>1000000000 and Type='BFC') as BONE3 on BONE2.Foreign_ID= BONE3.Foreign_ID
left join (select Text1,Qty,Amount,BON_ID,Cancelled,Foreign_ID from BONE where Type='POS') as BONE4 on BONE4.BON_ID=StraussBON_ID and BONE4.Cancelled=0
where  BONE.Type LIKE '%RB' and BON.cancelled=0 and BONE.Cancelled=0 and BONE.Cancelled=0 and BON.Type='CLS' and Typ IS NOT 'GRB';



GRB
select BONE.BONE_ID,BON.BON_ID,case when BONE3.BON_ID>0 then BONE4.Text1 else BONE2.Text1 end as Produkt,BONE2.Qty,BONE2.Amount,BONE.Qty,BONE2.Foreign_ID,case when BONE2.Foreign_ID<1000000000 then BONE2.Foreign_ID else BONE4.Foreign_ID end as ProdID,BONE2.TS,* from BONE
left join BON on BON.BON_ID=BONE.BON_ID
left join  BONE as BONE2 on BONE.BON_ID=BONE2.BON_ID and BONE2.Cancelled=0
left join (select BON_ID,Foreign_ID from BONE where Foreign_ID>1000000000 and (Type='BFC' or Type='NPP') as BONE3 on BONE2.Foreign_ID= BONE3.Foreign_ID
left join (select Text1,Qty,Amount,BON_ID,Cancelled,Foreign_ID from BONE where Type='POS') as BONE4 on BONE4.BON_ID=BONE3.BON_ID and BONE4.Cancelled=0
where  BONE.Type IS 'GRB' and BON.cancelled=0 and BONE.Cancelled=0 and BONE.Cancelled=0 and BON.Type='CLS'and BONE2.Type='POS';


*/


CReports.prototype.createReports = function(i, defret, start, end) {


    var me = POS.Reports;
    if (!defret) defret = jQuery.Deferred();
//    POS.Reports.sqlite3 = require('sqlite3');
  var myDir=fs.getMyDir();
 var reports = new CSQlite(myDir + "var/db/POSysseus_Reports.db")
    if (!i) i = 0;

    if (i > POS.Reports.Reports.length - 1) {
        defret.resolve();

        return 1;
    }

    var tablename = POS.Reports.Reports[i];
    debugger;
    var sql = "SELECT max(DAY) as maxday from " + tablename;

 $.when(reports.execute(sql)).then(function(firstdayrow) {
    //reports.all(sql, function(err, firstdayrow) {
    	if (start){
		firstdayrow=start;
	} else {
        	if (!(firstdayrow)) {
            		log.add(1, "Error POS_Reports " + tablename, "Error: keine Daten (err ist in diesem Zweig nie gesetzt)", null);
            		//defret.resolve();
            		POS.Reports.createReports(i + 1, defret, start, end);
            	return 0;
        	}
	}

	if (end){
		var enddate=end;
		var endunixtime = new Date((enddate + 'T23:59:59')) / 1000;
	} else{
        	var now = new Date();
        	enddate = me.unixtimeToDatestring(now / 1000)
        	endunixtime = new Date((enddate + 'T23:59:59')) / 1000;
	}

        if (firstdayrow && firstdayrow.length > 0) {
            var startdate = firstdayrow[0].maxday;
            if (startdate == null) {
                var startunixtime = endunixtime - (14 * 60 * 60 * 24); //14 Tage zurück
                startdate = me.unixtimeToDatestring(startunixtime);
            } else {
                startunixtime = new Date(startdate + "T00:00:00") / 1000;
            }
        }

        switch (tablename) {
            case "DAILY":
                var createfunction = me.createDailyReport;
                var prefunction = function() {
                    return 0
                };
                break;
            case "PRODSELLINGS":
                //createfunction = me.ProdsellingsReport;
		createfunction =  function() {
                    return 0
                };

                //prefunction = me.importReportsFromSlaves;
                var prefunction = function() {
                    return 0
                };
                break;
            case "AFIS_Geldschein":
                createfunction = me.createAFISReport;
                var prefunction = function() {
                    return 0
                };
                break;

        }
        $.when(prefunction(me)).then(function() {
            $.when(createfunction(startunixtime, endunixtime, startdate, enddate, reports, me)).then(function() {
                POS.Reports.createReports(i + 1, defret, start, end);
                return;
            });
        });
    });
    return defret.promise();
}



/*
CReports.prototype.ProdSellings = function(starttime, endtime, POS, me) {
        POS.hourGlass.show("Generiere Reports!");
        //var me = this;
        me.POS = POS;
        me.jQuery = $; //require('/home/pos/lib/jQuery/jquery-2.1.4.js');
        var args = new Array(starttime, endtime, me);
        //POS.timeout.register("CReporting", this.doProdSellings, args, 4, 1);
        return me.makeReports(args);
    }*/
/* Geldscheine
    100er Abfrage:
    select UName,Day,sum(case when PAY=100 then 1 else 0 end) as PAY100,sum(case when (PAY=200 and RET>100) then 1 else 0 end) as PAY200_100,sum(case when (PAY=100 and RET>50) then 1 when (PAY=200 and RET>100) then -1 else 0 end) as PAY100MIN from (select B1.BON_ID,BON.UName as UName,date(B1.TS,'unixepoch') as DAY, (B1.AMOUNT) as PAY, B1.Type as Type,(B2.AMOUNT) as RET, B2.Type as Type2  from BONE as B1 left join BONE as B2 on B1.BON_ID=B2.BON_ID left join BON on BON.BON_ID=B1.BON_ID where B1.Type ='PAY' and B2.Type='RET' and B1.cancelled=0 and BON.cancelled=0) group by DAY,UName

    CREATE TABLE `AFIS_Geldschein` (
    	`UName`	TEXT,
    	`DAY`	TEXT,
    	`PAY100`	INTEGER,
    	`PAY200_100`	INTEGER,
    	`PAY100MIN`	INTEGER
    );
Gelddifferenz -> Storniert und Summe niedrig
select date,BON_ID,Qty,ZahlSumme,ReturnSumme,POSSumme,(POSSumme-ZahlSumme+ReturnSumme) as Differenz,Foreign_ID,Text1,UID,User,Bontype,Customer from
(select datetime(BONE.TS,'unixepoch') as date,BON.BON_ID as ID,Qty,SUM(CASE WHEN (BONE.Type='PAY') THEN Amount ELSE 0 END) as ZahlSumme,SUM(CASE WHEN (BONE.Type='RET') THEN Amount ELSE 0 END) as ReturnSumme,SUM(CASE WHEN (BONE.Type='POS') THEN Amount ELSE 0 END) as POSSumme,Foreign_ID,Text1,BON.U_ID as UID,BON.UName as User,BON.Type as Bontype,CUST_ID as Customer from BONE left join BON on BON.BON_ID=BONE.BON_ID where TS>1470405779 and BON.Type='CLS' group by ID) where Differenz>4 and Text1!='BCC' and Zahlsumme<5;

CREATE TABLE `AFIS_Gelddifferenz` (
	`Date`	TEXT,
	`BON_ID`	INTEGER,
	`Qty`	INTEGER,
	`PaySum`	REAL,
	`ReturnSum`	REAL,
	`POSSum`	REAL,
	`Diff`	REAL,
	`Foreign_ID`	INTEGER,
	`Text1`	TEXT,
	`U_ID`	INTEGER,
	`UName`	TEXT,
	`BonType`	TEXT,
	`Customer`	TEXT
);

    */

CReports.prototype.insertEmptyProductDays = function(me, reports, rows, startunixtime, endunixtime) {
    var defret = jQuery.Deferred();
    var Days = [];
    var unixtime = startunixtime;
    var Datum = me.unixtimeToDatestring(unixtime);
    var EndDate = me.unixtimeToDatestring(endunixtime);
    var j = 0;


    while (Datum <= EndDate && j < 100) {
        found = 0;
        for (var i = 0; i < rows.length; i++) {
            if (rows[i].DAY == Datum) {
                found = 1;
                continue;
            }
        }
        if (found == 0) {
            Days.push(Datum);
        }
        unixtime = unixtime + 24 * 60 * 60;
        Datum = me.unixtimeToDatestring(unixtime);
        j = j + 1;
    }

    var iterator2 = function it(i) {
        if (i < Days.length) {
            var sql = "INSERT OR IGNORE INTO PRODSELLINGS (POS_ID,DAY,Type,ProdName,Delivered,Expirated,Sold,\
              SellPrice,SellUnitPrice,BuyPrice,BuyUnitPrice,GroupName,Button) VALUES \
              (" + POS.POSId + ",'" + Days[i] + "','RPR','',0,0,0,0,0,0,0,'','');";
 	$.when(reports.execute(sql)).then(function(row2) {
                if (!(row2)) {
                    log.add(1, "Error Insert Prodsellings " + sql, "Error: keine Daten (err ist in diesem Zweig nie gesetzt)", null);
                }
                iterator2(i + 1);
            });
        } else {
            //POS.hourGlass.hide();
            //reports.close();
            log.add(2, "Info ", "Generiere Empty Prodsellings Ende!");
            defret.resolve();
            return;
        }
    }
    iterator2(0);
    return defret.promise();
}

CReports.prototype.ProdsellingsReport = function(startunixtime, endunixtime, startdate, enddate, reports, me) {
    var defret = jQuery.Deferred();
    var me = POS.Reports;
    var tablename = "PRODSELLINGS";
    /*if (POS.POSType == "Master" && POS.otherPOS.length > 1) { //get Data from Slaves
        tablename = tablename + "master";
    }*/

    //var queries = ["SLD", "BNC", "EXP", "RPR"];
    var queries = ["SLD", "BNC", "RPR", "GRB", "xRB"];
    log.add(2, "Info ", "Generiere " + tablename + " Reports!");
    sql = "DELETE FROM " + tablename + " where DAY>='" + startdate + "'";
 $.when(reports.execute(sql)).then(function(row1) {

        var iterator3 = function it(z) {

            if (z < queries.length) {
                var query = queries[z];
                if (query == "SLD") {
                    var sql = me.generateProductSQL(startunixtime, endunixtime);
					console.log("SLD"+sql);
                } else if (query == "BNC") {
                    sql = me.getBunchesSQL(startunixtime, endunixtime);
					console.log("BNC: "+sql);

                } else if (query == "EXP") {
                    sql = me.generateEXPProductSQL(startunixtime, endunixtime);
			console.log("EXP: "+sql);

                } else if (query == "RPR") {
                    sql = me.generateRPRSQL(startunixtime, endunixtime);
			console.log("RPR: "+sql);

                } else if (query == "GRB") {
                    sql = me.generateGRBSQL(startunixtime, endunixtime);
			console.log("GRB: "+sql);

                } else if (query == "xRB") {
                    sql = me.generatexRBSQL(startunixtime, endunixtime);
			console.log("xRB: "+sql);

                }

                $.when(me.db.execute(sql, true)).done(function(rows) { 
                    var sql = "BEGIN TRANSACTION;";
		 $.when(reports.execute(sql, true)).done(function(row1){ 
                        day = DateToString(new Date(startunixtime * 1000));
                        var def = jQuery.Deferred();
			if (rows){
                        	var j = Object.keys(rows);
			} else {
				j=0;
			}
                        var iterator2 = function it(i) {
                            if (i < j.length) {
                                var row = j[i];
                                sql = me.createInsertSQL(rows, row, day, query, tablename);
				 $.when(reports.execute(sql, true)).done(function(row1){                               
         				console.log(sql);
                                    iterator2(i + 1);
                                });
                            } else {
                                if (query == "SLD") {
                                    $.when(me.insertEmptyProductDays(me, reports, rows, startunixtime, endunixtime)).done(function() {
                                        def.resolve();
                                    });
                                } else {
                                    def.resolve(row1);
                                }
                            }
                        }
                        iterator2(0);
                        $.when(def).done(function(rows) {
                            sql = "COMMIT";
 			    $.when(reports.execute(sql, true)).done(function(row1){
                                //iterator(starttime + (60 * 60 * 24));
                                iterator3(z + 1);
                                sql = "";
                            });
                        });
                    });
                }).fail(function(err) {
                    console.log(err + sql);
                    iterator3(z + 1);
                }).always(function(err) {
                    //iterator(starttime + (60 * 60 * 24));
                });
            } else {
                //$.when(me.unionProdSellings(startdate, enddate, reports)).then(function() {
                //POS.hourGlass.hide();
                //reports.close();
                log.add(2, "Info ", "Generiere PRODSELLINGS Reports Ende!");
                defret.resolve();
                return;
                //});
            }
        }
        iterator3(0);
    });
    return defret.promise();
    //me.POS.timeout.unregister(" CReporting ");
}


CReports.prototype.createAFISReport = function(startunixtime, endunixtime, startdate, enddate, reports, me) {

    log.add(2, "Info ", "Generiere AFIS Reports!");
    /*
    CREATE TABLE `AFIS_Geldschein` (
      `UName`	TEXT,
      `DAY`	TEXT,
      `PAY100`	INTEGER,
      `PAY200_100`	INTEGER,
      `PAY100MIN`	INTEGER
    );

    PAY100: Mit wievielen 100ern wurde bezahlt
    PAY200_100: wievil 100er könnten  bei 200er Zahlungen zurückgegeben worden sein
    PAY100MIN wieviele 100er sollten minmal drinnen sein

    */
    var defret = jQuery.Deferred();

    var GS100sql = "SELECT UName,DAY,sum(case when PAY=100 then 1 else 0 end) as PAY100,sum(case when (PAY=200 and RET>100) then 1 else 0 end) as PAY200_100," +
        "sum(case when (PAY=100 and RET>50) then 1 when (PAY=200 and RET>100) then -1 else 0 end) as PAY100MIN from (select B1.BON_ID,BON.UName as UName,date(B1.TS,'unixepoch') as DAY" +
        ", (B1.AMOUNT) as PAY, B1.Type as Type,(B2.AMOUNT) as RET, B2.Type as Type2  from BONE as B1 left join BONE as B2 on B1.BON_ID=B2.BON_ID left join BON on BON.BON_ID=B1.BON_ID " +
        "where B1.TS>=" + startunixtime + " and B1.TS<=" + endunixtime + " and B1.Type ='PAY' and B2.Type='RET' and B1.cancelled=0 and BON.cancelled=0) group by DAY,UName";


    /*

    CREATE TABLE `AFIS_Gelddifferenz` (
    	`Date`	TEXT,
    	`BON_ID`	INTEGER,
    	`Qty`	INTEGER,
    	`PaySum`	REAL,
    	`ReturnSum`	REAL,
    	`POSSum`	REAL,
    	`Diff`	REAL,
    	`Foreign_ID`	INTEGER,
    	`Text1`	TEXT,
    	`U_ID`	INTEGER,
    	`UName`	TEXT,
    	`BonType`	TEXT,
    	`Customer`	INTEGER
    );
    */
/*
    var diffsql = "SELECT Date,BON_ID,Qty,PaySum,ReturnSum,POSSum,(POSSum-PaySum+ReturnSum) as Diff,Foreign_ID,Text1,U_ID,UName,BonType,Customer from \
(select datetime(BONE.TS,'unixepoch') as Date,BON.BON_ID as BON_ID,Qty,SUM(CASE WHEN (BONE.Type='PAY') THEN Amount ELSE 0 END) as PaySum,SUM(CASE WHEN (BONE.Type='RET') \
THEN Amount ELSE 0 END) as ReturnSum,SUM(CASE WHEN (BONE.Type='POS') THEN Amount ELSE 0 END) as POSSum,Foreign_ID,Text1,BON.U_ID as U_ID,BON.UName,BON.Type as BonType,CUST_ID as Customer\
 from BONE left join BON on BON.BON_ID=BONE.BON_ID where TS>=" + startunixtime + " and TS<=" + endunixtime +
        " and BON.Type='CLS' group by BON.BON_ID) where  Diff>4 and Text1!='BCC' and PaySum<5 and PAYSum>0";

*/
var diffsql = "SELECT Date,BON_ID,Qty,PaySum,ReturnSum,POSSum,(POSSum-PaySum+ReturnSum) as Diff,Foreign_ID,Text1,U_ID,UName,BonType,Customer from \
(select datetime(BONE.TS,'unixepoch') as Date,BON.BON_ID as BON_ID,Qty,SUM(CASE WHEN (BONE.Type='PAY') THEN Amount ELSE 0 END) as PaySum,SUM(CASE WHEN (BONE.Type='RET') \
THEN Amount ELSE 0 END) as ReturnSum,SUM(CASE WHEN (BONE.Type='POS') THEN Amount ELSE 0 END) as POSSum,Foreign_ID,Text1,BON.U_ID as U_ID,BON.UName,BON.Type as BonType,CUST_ID as Customer\
 from BONE left join BON on BON.BON_ID=BONE.BON_ID where TS>=" + startunixtime + " and TS<=" + endunixtime +
        " and BON.Type='CLS' group by BON.BON_ID) where  Diff>5 and Diff/POSSum>0.7 and Text1!='BCC' and PAYSum>0";


    var saldosql = "SELECT UName, date(TS,'unixepoch')  as Day, round(sum(case when ((BONETABLE.Type='POP' or BONETABLE.Type='PCC' or BONETABLE.Type='PCT') and BONETABLE.Unit='BAR') then " +
        "(case when BONETABLE.Type='PCC' then BONETABLE.Qty else (-1)*BONETABLE.Qty end) else 0 end),2) as Bargeldsaldo " +
        "from (select * from BONE where TS >= " + startunixtime + " AND TS <=" + endunixtime + " and BONE.Cancelled=0) as BONETABLE " +
        "left join BON on BON.BON_ID=BONETABLE.BON_ID where  (BON.Type='PCT'  or BON.Type='PCR' or BON.Type='PCC') and BONETABLE.Amount_Unit=100 " +
        "and  BON.Cancelled=0 group by Day,UName;";
    $.when(me.db.execute(saldosql), true).done(function(res) {
        $.when(me.db.execute(GS100sql), true).done(function(rows) {
            var sql = "DELETE FROM AFIS_Geldschein where DAY>='" + startdate + "'";
 		$.when(reports.execute(sql, true)).done(function(row1){            
                //var sql = "";
                var j = Object.keys(rows);
                var iterator2 = function it(i) {
                    if (i < j.length) {
                        var row = rows[i];
                        var result = $.grep(res, function(e) {
                            return (e.DAY == row.DAY && e.UName == row.UName);
                        });
                        if (!result[0] || !result[0].Bargeldsaldo) {
                            iterator2(i + 1);
                            return;
                        }
                        sql = "INSERT into AFIS_Geldschein VALUES ('" + row.UName + "','" + row.DAY + "'," + row.PAY100 + "," + row.PAY200_100 + "," + row.PAY100MIN + "," + result[0].Bargeldsaldo + ")";
                        $.when(reports.execute(sql, true)).done(function(row2){
                            if (!(row2)) {
                                log.add(1, "Error Insert AFIS_Geldschein " + sql, "Error: keine Daten (err ist in diesem Zweig nie gesetzt)", null);
                            }
                            iterator2(i + 1);
                        });

                    } else {
                        //POS.hourGlass.hide();
                        $.when(me.db.execute(diffsql), true).done(function(rows) {
                            var sql = "DELETE FROM AFIS_Gelddifferenz where Date>='" + startdate + "'";
 			$.when(reports.execute(sql, true)).done(function(row1){
                                //var sql = "";
                                var j = Object.keys(rows);
                                var iterator3 = function it(i) {
                                    if (i < j.length) {
                                        var row = rows[i];
                                        sql = "INSERT into AFIS_Gelddifferenz VALUES ('" + row.Date + "'," + row.BON_ID + "," + row.Qty + "," + row.PaySum + "," + row.ReturnSum + "," +
                                            row.POSSum + "," + row.Diff + "," + row.Foreign_ID + ",'" + row.Text1 + "'," + row.U_ID + ",'" + row.UName + "','" + row.BonType + "'," + row.Customer + ")";
                                        $.when(reports.execute(sql, true)).done(function(row2){
                                            if (!(row2)) {
                                                log.add(1, "Error Insert AFIS_Gelddifferenz " + sql, "Error: keine Daten (err ist in diesem Zweig nie gesetzt)", null);
                                            }
                                            iterator3(i + 1);
                                        });
                                    } else {
                                        //POS.hourGlass.hide();
                                        //      reports.run(diffsql, function(err, row) {
                                        log.add(2, "Info ", "Generiere AFIS Reports Ende!");
                                        //reports.close();
                                        defret.resolve();
                                        //    });
                                        return;
                                    }
                                }
                                iterator3(0);
                            });

                        });
                        return;
                    }
                };
                iterator2(0);
            });
        });

    });

    return defret.promise();
}


CReports.prototype.createDailyReport = function(startunixtime, endunixtime, startdate, enddate, reports, me) {

    var dailysql = "SELECT BON.UName as UName, date(BONETABLE.TS,'unixepoch')  as Day,round(sum(case when (BONETABLE.Type='PAY' or BONETABLE.Type='RET' or BONETABLE.Type='CDS')  \
    then (case when BONETABLE.Type='PAY' then  BONETABLE.Amount else  (-1)*BONETABLE.Amount end) else 0 end),2) as Umsatz, \
    (case when BONETABLE.TS>=BON1.Start then 'NM' else 'VM' end) as AM_PM, \
    round(sum(case when BONETABLE.Type='POS' then BONETABLE.Amount else 0 end),2) as Listpreissumme, \
    round(sum(case when BONETABLE.Type LIKE '%RB' then BONETABLE.Amount else 0 end),2) as Rabatte, \
    round(sum(case when BONETABLE.Type='CDS' then BONETABLE.Amount else 0 end),2) as Gutschriften,\
    round(sum(case when BONETABLE.Type='REC' then BONETABLE.Amount else 0 end),2) as Reklamation,\
    round(sum(case when BONETABLE.Text1='VCR' then BONETABLE.Amount else 0 end),2) as Gutscheinzahlung,\
    round(sum(case when BONETABLE.Text1='PPC' then BONETABLE.Amount else 0 end),2) as Wertkarten,\
    round(sum(case when (BONETABLE.Text2='DCP' or BONETABLE.Text2='BC') then BONETABLE.Amount else 0 end),2) as Bankomatzahlungen,\
    round(sum(case when (BONETABLE.Text2='CCP' or BONETABLE.Text2='CC') then BONETABLE.Amount else 0 end),2) as Kreditkartenzahlungen,\
    round(sum(case when (((BONETABLE.Type='PAY' or BONETABLE.Type='RET') and BONETABLE.Text1='BAR') or BONETABLE.Type='CDS') then (case when BONETABLE.Type='PAY' then BONETABLE.Amount else (-1)*BONETABLE.Amount end) else 0 end),2) as BAR,\
    round( sum(case when BONETABLE.Text1='PPU' then BONETABLE.Amount else 0 end),2) as Personalkauf, \
    0 as Bargeldsaldo,\
    0 as Bar_abgeliefert,\
    sum(case when (BONETABLE.Type='PAY' and BON.Type='CLS') then 1 else 0 end) as Verkaeufe \
    from (select * from BONE where TS>=" + startunixtime + " and TS<=" + endunixtime + " and BONE.Cancelled=0) as BONETABLE  \
    left join BON on BON.BON_ID=BONETABLE.BON_ID \
    left join (select Start,Type from BON where Start>=" + startunixtime + " and Start<=" + endunixtime + " and Cancelled=0 group by Start,Type) as BON1 on date(BON1.Start,'unixepoch')=date(BONETABLE.TS,'unixepoch') and BON1.Type='PCT' \
    where  (BON.Type='CLS' or BON.Type='PCT' or BON.Type='POP' or BON.Type='PCR' or BON.Type='PCC') \
    and  BON.Cancelled=0 and BONETABLE.Interaction IS NOT 'PDN' \
    group by Day,AM_PM,BON.UName";
    /*
        var barsql = "SELECT BON.UName,date(BON.Start,'unixepoch') as Datum,Start,BON.Type, sum(Amount) as SUM from BON  \
        left join BONE on BON.BON_ID=BONE.BON_ID where Start>=1483227460 and Start<=1490999860 and BON.Cancelled=0 \
        and (BON.Type = 'POP' or BON.Type LIKE 'PC%') and BONE.Unit='BAR' group by Start,BON.Type";
    */
    var barsql = "SELECT BON.UName,date(BONE.TS,'unixepoch') as Datum,Start,BONE.Type, sum(Amount) as SUM from BONE  \
    left join BON on BON.BON_ID=BONE.BON_ID where TS>=" + startunixtime + " and TS<=" + endunixtime + "  and BON.Cancelled=0 \
    and (BONE.Type = 'POP' or BONE.Type LIKE 'PC%') and BONE.Unit='BAR' group by BONE.TS,BONE.Type;";

    /*
    var dailysql = "SELECT BON.UName as UName, date(BONETABLE.TS,'unixepoch')  as Day,round(sum(case when (BONETABLE.Type='PAY' or BONETABLE.Type='RET' or BONETABLE.Type='CDS')  \
    then (case when BONETABLE.Type='PAY' then  BONETABLE.Amount else  (-1)*BONETABLE.Amount end) else 0 end),2) as Umsatz, \
    (case when BONETABLE.TS>=BON1.Start then 'NM' else 'VM' end) as AM_PM, \
    round(sum(case when BONETABLE.Type='POS' then BONETABLE.Amount else 0 end),2) as Listpreissumme, \
    round(sum(case when BONETABLE.Type LIKE '%RB' then BONETABLE.Amount else 0 end),2) as Rabatte, \
    round(sum(case when BONETABLE.Type='CDS' then BONETABLE.Amount else 0 end),2) as Gutschriften,\
    round(sum(case when BONETABLE.Type='REC' then BONETABLE.Amount else 0 end),2) as Reklamation,\
    round(sum(case when BONETABLE.Text1='VCR' then BONETABLE.Amount else 0 end),2) as Gutscheinzahlung,\
    round(sum(case when BONETABLE.Text1='PPC' then BONETABLE.Amount else 0 end),2) as Wertkarten,\
    round(sum(case when (BONETABLE.Text2='DCP' or BONETABLE.Text2='BC') then BONETABLE.Amount else 0 end),2) as Bankomatzahlungen,\
    round(sum(case when (BONETABLE.Text2='CCP' or BONETABLE.Text2='CC') then BONETABLE.Amount else 0 end),2) as Kreditkartenzahlungen,\
    round(sum(case when (((BONETABLE.Type='PAY' or BONETABLE.Type='RET') and BONETABLE.Text1='BAR') or BONETABLE.Type='CDS') then (case when BONETABLE.Type='PAY' then BONETABLE.Amount else (-1)*BONETABLE.Amount end) else 0 end),2) as BAR,\
    round( sum(case when BONETABLE.Text1='PPU' then BONETABLE.Amount else 0 end),2) as Personalkauf, \
    round(sum(case when ((BONETABLE.Type='POP' or BONETABLE.Type='PCC' or BONETABLE.Type='PCT') and BONETABLE.Unit='BAR') then \
    (case when BONETABLE.Type='PCC' then BONETABLE.Amount else (-1)*BONETABLE.Amount end) else 0 end),2) as Bargeldsaldo,\
    round(sum(case when ((BONETABLE.Type='PCR' or BONETABLE.Type='PCC' or BONETABLE.Type='PCT') and BONETABLE.Unit='BAR') then \
    (case when BONETABLE.Type='PCC' then BONETABLE.Amount else (-1)*BONETABLE.Amount end) else 0 end),2) as Bar_abgeliefert,\
    sum(case when (BONETABLE.Type='PAY' and BON.Type='CLS') then 1 else 0 end) as Verkaeufe,\
    sum(case when (BONETABLE.Type='PCT' and BONETABLE.Unit='BAR') then BONETABLE.Amount else 0 end) as PCT \
    from (select * from BONE where TS>=" + startunixtime + " and TS<=" + endunixtime + " and BONE.Cancelled=0) as BONETABLE  \
    left join BON on BON.BON_ID=BONETABLE.BON_ID \
    left join (select Start,Type from BON where Start>=" + startunixtime + " and Start<=" + endunixtime + " and Cancelled=0 group by Start,Type) as BON1 on date(BON1.Start,'unixepoch')=date(BONETABLE.TS,'unixepoch') and BON1.Type='PCT' \
    where  (BON.Type='CLS' or BON.Type='PCT' or BON.Type='POP' or BON.Type='PCR' or BON.Type='PCC') \
    and  BON.Cancelled=0 \
    group by Day,AM_PM,BON.UName";
*/
    log.add(2, "Info ", "Generiere Daily Reports!");
    var defret = jQuery.Deferred();
    //var sql = "SELECT UName,substr(Date,1,10) as DAY, sum(TAXNormal) as TAXNormal,sum(TAXErm1) as TAXErm1,sum(TAXErm2) as TAXErm2,sum(TAXNull) as TAXNull, sum(TAXBes) as TAXBes,(sum(TAXNormal)+sum(TAXErm1)+sum(TAXErm2)+sum(TAXNull)+sum(TAXBes)) as TurnOverREG from BONREG left join BON on BON.BON_ID=BONREG.BON_ID where DAY>='" + startdate + "' and DAY <='" + enddate + "' group by substr(Date,1,10),UName;";
    var sql = "SELECT BON.UName,substr(Date,1,10) as DAY, (case when strftime('%s',Date)>=BON1.Start then 'NM' else 'VM' end) as AM_PM, sum(TAXNormal) as TAXNormal,sum(TAXErm1) as TAXErm1,sum(TAXErm2) as TAXErm2,sum(TAXNull) as TAXNull, sum(TAXBes) as TAXBes,(sum(TAXNormal)+sum(TAXErm1)+sum(TAXErm2)+sum(TAXNull)+sum(TAXBes)) as TurnOverREG from BONREG left join BON on BON.BON_ID=BONREG.BON_ID left join BON as BON1 on date(BON1.Start,'unixepoch')=substr(Date,1,10)and BON1.Type='PCT' where DAY>='" + startdate + "' and DAY <='" + enddate + "' group by substr(Date,1,10),AM_PM,BON.UName;";
    //var endtime = starttime + (60 * 60 * 24 - 1);
    $.when(me.db.execute(sql, true)).done(function(rowsreg) { //true=only local
        sql = "SELECT  UName,date(TS,'unixepoch') as DAY,sum(Amount) as VoucherPurchase from BONE left join PROD on PROD_ID=Foreign_ID left join BON on BON.BON_ID=BONE.BON_ID where EAN='VTPPC' and BONE.Cancelled=0 and BON.Cancelled=0 and TS >=" + startunixtime + " and TS<=" + endunixtime + " group by date(TS, 'unixepoch'),UNAME";
        $.when(me.db.execute(sql, true)).done(function(rowsvoucher) { //true=only local
            $.when(me.db.execute(dailysql, true)).done(function(rows) { //true=only local
                $.when(me.db.execute(barsql, true)).done(function(barrows) { //true=only local

                    var dailycash = [];
                    var Datum = '';
                    var dailybar = {};
                    for (var i = 0; i < barrows.length; i++) {

                        if (barrows[i].Type == 'PCC') {

                            if (Datum != barrows[i].Datum) {
                                //                            dailycash[Datum] = dailybar;
                                Datum = barrows[i].Datum;
                                dailybar = {
                                    'Barumsatz_VM': 0,
                                    'Barumsatz_NM': 0,
                                    'Bar_geliefert_VM': 0,
                                    'Bar_geliefert_NM': 0,
                                    'Datum': Datum,
                                    'UName_VM': '',
                                    'UName_NM': ''
                                }
                            }

                            var previous = 'POP';

                            if (i - 1 > -1 && barrows[i - 1].Type == 'POP') {
                                dailybar.Barumsatz_VM = Math.round((barrows[i].SUM - barrows[i - 1].SUM) * 100) / 100; //PCC-POP
                                dailybar.UName_VM = barrows[i].UName;
                                previous = 'POP';
                            } else if (i - 1 > -1 && barrows[i - 1].Type == 'PCT') {
                                dailybar.Barumsatz_NM = Math.round((barrows[i].SUM - barrows[i - 1].SUM) * 100) / 100; //PCC-PCT
                                dailybar.UName_NM = barrows[i].UName;
                                previous = 'PCT';
                            }
                            if (i + 1 < barrows.length && barrows[i + 1].Type == 'PCT') {
                                dailybar.Bar_geliefert_VM = Math.round(barrows[i].SUM - barrows[i + 1].SUM); //PCC-PCT
                            } else if (i + 1 < barrows.length && barrows[i + 1].Type == 'PCR') {
                                if (previous == 'POP') { //dann war kein PCT
                                    dailybar.Bar_geliefert_VM = Math.round(barrows[i].SUM - barrows[i + 1].SUM); //PCC-PCR
                                } else {
                                    dailybar.Bar_geliefert_NM = Math.round(barrows[i].SUM - barrows[i + 1].SUM); //PCC-PCR
                                }
                            }
                            dailycash[Datum] = dailybar;

                        }
                    }

                    //select substr(Date,1,10) as DAY, sum(TAXNormal) as TAXNornal,sum(TAXErm1) as TAXErm1,sum(TAXErm2) as TAXErm2,sum(TAXNull)as TAXNull, sum(TAXBes) as TAXBes,(sum(TAXNormal)+sum(TAXErm1)+sum(TAXErm2)+sum(TAXNull)+sum(TAXBes)) as TurnOverREG from BONREG group by substr(Date,1,10);
                    //select  sum(Amount) as VoucherPurchase from BONE left join PROD on PROD_ID=Foreign_ID left join BON on BON.BON_ID=BONE.BON_ID where EAN='VTPPC' and BONE.Cancelled=0 and BON.Cancelled=0;
                    sql = "DELETE FROM DAILY where DAY>='" + startdate + "'";
                     $.when(reports.execute(sql, true)).done(function(row1){
                        //var sql = "";
                        var j = Object.keys(rows);
                        var iterator2 = function it(i) {
                            if (i < j.length) {
                                var row = j[i];
                                sql = me.createDailyInsertSQL(rows, row, "DAILY", rowsreg, rowsvoucher, dailycash);
                                 $.when(reports.execute(sql, true)).done(function(row2){
                                    if (!(row2)) {
                                        log.add(1, "Error Insert Daily " + sql, "Error: keine Daten (err ist in diesem Zweig nie gesetzt)", null);
                                    }
                                    iterator2(i + 1);
                                });
                            } else {
                                //POS.hourGlass.hide();
                                //reports.close();
                                log.add(2, "Info ", "Generiere Daily Reports Ende!");
                                $.when(me.insertEmptyDays(me, reports, rows, startunixtime, endunixtime)).done(function() {
                                    defret.resolve();
                                });
                                return;
                            }
                        }
                        iterator2(0);
                        /*me.jQuery.when(def).done(function(rows) {
                            sql = "COMMIT";
                            reports.run(sql, function(err, row1) {
                                //iterator(starttime + (60 * 60 * 24));
                                iterator3(z + 1);
                                sql = "";
                            });
                        });*/
                    });
                });
            });
        });

    }).fail(function(err) {
        console.log(err + sql);
        defret.resolve();
        //log.add(1, " Error sql Reposrt : ", sqlProducts, null);
    });
    return defret.promise();
}


CReports.prototype.insertEmptyDays = function(me, reports, rows, startunixtime, endunixtime) {
    var defret = jQuery.Deferred();
    var Days = [];
    var unixtime = startunixtime;
    var Datum = me.unixtimeToDatestring(unixtime);
    var EndDate = me.unixtimeToDatestring(endunixtime);
    var j = 0;
    if (!POS.MasterID || POS.MasterID == undefined) {
        POS.MasterID = POS.POSId;
    }


    while (Datum <= EndDate && j < 100) {
        found = 0;
        for (var i = 0; i < rows.length; i++) {
            if (rows[i].Day == Datum) {
                found = 1;
                continue;
            }
        }
        if (found == 0) {
            Days.push(Datum);
        }
        unixtime = unixtime + 24 * 60 * 60;
        Datum = me.unixtimeToDatestring(unixtime);
        j = j + 1;
    }

    var iterator2 = function it(i) {
        if (i < Days.length) {
            var sql = "INSERT OR IGNORE INTO DAILY (POSID,POSIDMaster,UName,DAY,Turnover,ProductSum,Rebates,\
              CreditVouchers,VoucherPayments,PrepaidCard,CashCardPayments,CreditCardPayments,CashPayments,PersonalPurchase,CashBalance,TurnOverREG,TAXNormal,TAXErm1, \
              TAXErm2,TAXNull,TAXBes,VoucherPurchase,PurchaseCount,Claim,Cash,AM_PM) VALUES \
              (" + POS.POSId + "," + POS.MasterID + ",'','" + Days[i] + "',0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,'VM')";
	 $.when(reports.execute(sql, true)).done(function(row2){            
                if (!(row2)) {
                    log.add(1, "Error Insert Daily " + sql, "Error: keine Daten (err ist in diesem Zweig nie gesetzt)", null);
                }
                iterator2(i + 1);
            });
        } else {
            //POS.hourGlass.hide();
            //reports.close();
            log.add(2, "Info ", "Generiere Empty Days Ende!");
            defret.resolve();
            return;
        }
    }
    iterator2(0);
    return defret.promise();
}


CReports.prototype.createDailyInsertSQL = function(rows, row, tablename, rowsreg, rowsvoucher, dailycash) {
    /*  CREATE TABLE `DAILY` (
	`POS_ID`	INTEGER,
	`POSIDMaster`	INTEGER,
	`DAY`	TEXT,
	`Turnover`	REAL DEFAULT '0',
	`ProductSum`	REAL DEFAULT '0',
	`Rebates`	REAL DEFAULT '0',
	`CreditVouchers`	REAL DEFAULT '0',
	`VoucherPayments`	REAL DEFAULT '0',
  PrepaidCard
	`CashCardPayments`	REAL DEFAULT '0',
	`CreditCardPayments` REAL default '0',
	`CashPayments`	REAL DEFAULT '0',
	`PersonalPurchase`	REAL DEFAULT '0',
	`CashBalance`	REAL DEFAULT '0',
	`TurnOverREG`	REAL DEFAULT '0',
	`TAXNornal`	REAL DEFAULT '0',
	`TAXErm1`	REAL DEFAULT '0',
	`TAXErm2`	REAL DEFAULT '0',
	`TAXNull`	REAL DEFAULT '0',
	`TAXBes`	REAL DEFAULT '0',
	`VoucherPurchase`	REAL DEFAULT '0'
  PurchaseCount
 )
    )*/
    if (!POS.Master) {
        POS.Master = POS.POSId;
    }

    var day = rows[row].Day;

    var TurnOverREG = 0;
    var TAXNormal = 0;
    var TAXErm1 = 0;
    var TAXErm2 = 0;
    var TAXNull = 0;
    var TAXBes = 0;
    var VoucherPurchase = 0;

    for (var i = 0; i < rowsvoucher.length; i++) {
        if (rowsvoucher[i].DAY == day && rowsvoucher[i].UName == rows[row].UName) {
            VoucherPurchase = Math.round(rowsvoucher[i].VoucherPurchase * 100) / 100;
        }
    }

    if (!POS.MasterID || POS.MasterID == undefined) {
        POS.MasterID = POS.POSId;
    }



    /*
        if (rows[row].Bar_abgeliefert != 0 && rows[row].PCT > 0) {
            var barabgel = Math.round((rows[row].Bar_abgeliefert + rows[row].PCT) * 100) / 100; *
            if ((barabgel - parseInt(barabgel)) == 0) { //check ob ganze Zahl
                rows[row].Bar_abgeliefert = barabgel;
                rows[row].Bargeldsaldo = barabgel;
            }
        } else if (rows[row].Bar_abgeliefert > 0 && rows[row].PCT == 0) {
            var date = rows[row].Day;
            var j = Math.max(row - 6, 0);
            var k = Math.min(j + 12, rows.length);

            for (var x = j; x < k; x++) {
                if (rows[x].Day == date && rows[x].PCT > 0) {
                    if (rows[row].AM_PM != rows[x].AM_PM) {
                        var barabgel = Math.round((rows[row].Bar_abgeliefert - rows[x].PCT) * 100) / 100;
                        if ((barabgel - parseInt(barabgel)) == 0) { //check ob ganze Zahl
                            rows[row].Bar_abgeliefert = barabgel;
                        }
                    } else if (rows[row].AM_PM == rows[x].AM_PM) {
                        var barsaldo = Math.round((rows[row].Bargeldsaldo - rows[x].PCT) * 100) / 100;
                        if (barsaldo > 0) {
                            rows[row].Bargeldsaldo = barsaldo;
                        }
                    }
                }
            }
        }
    */
    /*
        dailybar = {
            'Barumsatz_VM': 0,
            'Barumsatz_NM': 0,
            'Bar_geliefert_VM': 0,
            'Bar_geliefert_NM': 0,
            'Datum': Datum,
            'UName_VM': '',
            'UName_NM': ''
        }
        */

    if (dailycash[rows[row].Day]) {
        var Day = rows[row].Day;
        if (rows[row].AM_PM == 'VM' && dailycash[Day].UName_VM == rows[row].UName) {
            rows[row].Bar_abgeliefert = dailycash[Day].Bar_geliefert_VM;
            rows[row].Bargeldsaldo = dailycash[Day].Barumsatz_VM;
        } else if (rows[row].AM_PM == 'NM' && dailycash[Day].UName_NM == rows[row].UName) {
            rows[row].Bar_abgeliefert = dailycash[Day].Bar_geliefert_NM;
            rows[row].Bargeldsaldo = dailycash[Day].Barumsatz_NM;
        }
    }


    for (var i = 0; i < rowsreg.length; i++) {
        if (rowsreg[i].DAY == day && rowsreg[i].UName == rows[row].UName && rowsreg[i].AM_PM == rows[row].AM_PM) {
            TurnOverREG = Math.round(rowsreg[i].TurnOverREG * 100) / 100;
            TAXNormal = Math.round(rowsreg[i].TAXNormal * 100) / 100;
            TAXErm1 = Math.round(rowsreg[i].TAXErm1 * 100) / 100;
            TAXErm2 = Math.round(rowsreg[i].TAXErm2 * 100) / 100;
            TAXNull = Math.round(rowsreg[i].TAXNull * 100) / 100;
            TAXBes = Math.round(rowsreg[i].TAXBes * 100) / 100;
            break;
        }
    }

    var sql = "INSERT OR IGNORE INTO " + tablename + " (POSID,POSIDMaster,UName,DAY,Turnover,ProductSum,Rebates,\
      CreditVouchers,VoucherPayments,PrepaidCard,CashCardPayments,CreditCardPayments,CashPayments,PersonalPurchase,CashBalance,TurnOverREG,TAXNormal,TAXErm1, \
      TAXErm2,TAXNull,TAXBes,VoucherPurchase,PurchaseCount,Claim,Cash,AM_PM) VALUES \
      (" + POS.POSId + "," + POS.MasterID + ",'" + rows[row].UName + "','" + rows[row].Day + "'," + rows[row].Umsatz + "," + rows[row].Listpreissumme + "," + rows[row].Rabatte + "," + rows[row].Gutschriften + "," +
        rows[row].Gutscheinzahlung + "," + rows[row].Wertkarten + "," + rows[row].Bankomatzahlungen + "," + rows[row].Kreditkartenzahlungen + "," + rows[row].BAR +
        "," + rows[row].Personalkauf + "," + rows[row].Bargeldsaldo + "," + TurnOverREG + "," + TAXNormal + "," + TAXErm1 + "," + TAXErm2 + "," + TAXNull + "," + TAXBes + "," +
        VoucherPurchase + "," + rows[row].Verkaeufe + "," + rows[row].Reklamation + "," + rows[row].Bar_abgeliefert + ",'" + rows[row].AM_PM + "')";

    return sql;
}


CReports.prototype.unixtimeToDatestring = function(unixtime) {

    return DateToString(new Date(unixtime * 1000));
    /*  var startday = new Date(unixtime * 1000);
      var year = startday.getFullYear();
      var month = ("0" + (startday.getMonth() + 1)).substr(-2);
      var day = ("0" + startday.getDate()).substr(-2);
      startday = year + "-" + month + "-" + day;
      return startday;*/
}


CReports.prototype.unionProdSellings = function(startday, endday, reports) { //union into PRODSELLINGS
    var defret = jQuery.Deferred();



    if (POS.POSType == "Master" && POS.otherPOS.length > 1) {
        /*    var sql3 = require('sqlite3');
        var reports = new sql3.Database("var//POSysseus_Reports."); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);
*/
        var sql = "INSERT OR IGNORE into PRODSELLINGS SELECT POS_ID,DAY,Type,ProdName,sum(Delivered) as Delivered,SUM(Expirated) as Expirated,SUM(SoldQty) as Sold,SUM(VKPreis) as SellPrice,SellUnitPrice,BuyUnitPrice,SUM(EKPreis) as BuyPrice,GroupName,Button  from  \
        (SELECT POS_ID,DAY,Type,ProdName,sum(Delivered) as Delivered,SUM(Expirated) as Expirated,SUM(Sold) as SoldQty,SUM(SellPrice) as VKPreis,SellUnitPrice,BuyUnitPrice,SUM(BuyPrice) as EKPreis,GroupName,Button from PRODSELLINGSmaster \
        where DAY>= '" + startday + "' and DAY< '" + endday + "'  group by DAY,ProdName ";
        for (var i = 0; i < POS.otherPOS.length; i++) {
            if (POS.otherPOS[i].Type && POS.otherPOS[i].Type == "Slave") {
                var name = "";
                var ips = POS.otherPOS[i].address.split(".");
                name = "slave" + ips[3];
                sql += " UNION ALL " +
                    "SELECT POS_ID,DAY,Type,ProdName,sum(Delivered) as Delivered,SUM(Expirated) as Expirated,SUM(Sold) as SoldQty,SUM(SellPrice) as VKPreis,SellUnitPrice,BuyUnitPrice,SUM(BuyPrice) as EKPreis,GroupName,Button from PRODSELLINGS" +
                    name + " where DAY>= '" + startday + "' and DAY< '" + endday + "'  group by DAY,ProdName ";
            }
        }
        sql += ") group by DAY,ProdName;";

        var sql2 = "DELETE from PRODSELLINGS where DAY >='" + startday + "' and DAY< '" + endday + "'";
 	$.when(reports.execute(sql2, true)).done(function(row){        
 		$.when(reports.execute(sql, true)).done(function(row){
                //reports.close();
                defret.resolve();
            });
        });

    } else {
        defret.resolve();

    }
    return defret.promise();

}

CReports.prototype.createUnionSQL = function(row, day, query, tablename) { //not used

    var startday = "";
    var endday = "";


    return "INSERT OR IGNORE into PRODSELLINGS SELECT POS_ID,DAY,Type,ProdName,sum(Delivered) as Delivered,SUM(Expirated) as Expirated,SUM(SoldQty) as Sold,SUM(VKPreis) as SellPrice,SellUnitPrice,BuyUnitPrice,SUM(EKPreis) as BuyPrice,GroupName,Button  from  \
    (SELECT POS_ID,DAY,Type,ProdName,sum(Delivered) as Delivered,SUM(Expirated) as Expirated,SUM(Sold) as SoldQty,SUM(SellPrice) as VKPreis,SellUnitPrice,BuyUnitPrice,SUM(BuyPrice) as EKPreis,GroupName,Button from PRODSELLINGSmaster \
    where DAY>= '" + startday + "' and DAY <='" + endday + "' group by DAY,ProdName 	UNION ALL \
    SELECT POS_ID,DAY,Type,ProdName,sum(Delivered) as Delivered,SUM(Expirated) as Expirated,SUM(Sold) as SoldQty,SUM(SellPrice) as VKPreis,SellUnitPrice,BuyUnitPrice,SUM(BuyPrice) as EKPreis,GroupName,Button from PRODSELLINGSslave1 \
    where DAY>= '" + startday + "' and DAY <='" + endday + "' group by DAY,ProdName 	UNION ALL  \
    SELECT POS_ID,DAY,Type,ProdName,sum(Delivered) as Delivered,SUM(Expirated) as Expirated,SUM(Sold) as SoldQty,SUM(SellPrice) as VKPreis,SellUnitPrice,BuyUnitPrice,SUM(BuyPrice) as EKPreis,GroupName,Button from PRODSELLINGSslave2 \
    where DAY>= '" + startday + "' and DAY <='" + endday + "' group by DAY,ProdName \
  ) group by ProdName;";

}


CReports.prototype.createInsertSQL = function(rows, row, day, query, tablename) {
    return "INSERT OR IGNORE INTO " + tablename + " (POS_ID,DAY,Type,ProdName,Delivered,Expirated,Sold,\
      SellPrice,SellUnitPrice,BuyPrice,BuyUnitPrice,GroupName,Button) VALUES \
      (" + POS.POSId + ",'" + rows[row].DAY + "','" + rows[row].Type + "','" + rows[row].NameProd + "'," + (rows[row].DelivQty || 0) + "," + (rows[row].ExpirQty || 0) + "," +
        rows[row].SoldQty + "," + (rows[row].VKPreis || 0) + "," + rows[row].VKEPreis +
        "," + (rows[row].EKPreis || 0) + "," + (rows[row].EKEPreis || 0) + ",'" + rows[row].GroupName + "','" + rows[row].ProdId + "');";

}

CReports.prototype.createSQliteInsertSQL = function(rows, row, day, query, tablename) {
    return "INSERT OR IGNORE INTO " + tablename + " (POS_ID,DAY,Type,ProdName,Delivered,Expirated,Sold,\
      SellPrice,SellUnitPrice,BuyPrice,BuyUnitPrice,GroupName,Button) VALUES \
      (" + POS.POSId + ",'" + rows[row].DAY + "','" + rows[row].Type + "','" + rows[row].ProdName + "'," + (rows[row].Delivered || 0) + "," + (rows[row].Expired || 0) + "," +
        rows[row].Sold + "," + (rows[row].SellPrice || 0) + "," + rows[row].SellUnitPrice +
        "," + (rows[row].BuyPrice || 0) + "," + (rows[row].BuyUnitPrice || 0) + ",'" + rows[row].GroupName + "','" + rows[row].Button + "');";
}

/*CReports.prototype.generateSLDProductSQL = function(starttime, endtime) {

    return "SELECT RES1.NameProd, DelivQty,  ROUND(ExpirQty, 0) as ExpirQty, ROUND(SoldQty, 0) as SoldQty, RES1.VKPreis, RES1.VKEPreis, RES1.EKPreis, RES1.EKPreis/RES1.SoldQty as EKEPreis, RES1.GroupName, RES1.ProdId,RES1.DAY as DAY FROM (" +
    this.getSLDProductSQL(starttime, endtime) + ") AS RES1  \
    LEFT JOIN (" + this.getDLVSQL(starttime, endtime) + ") AS RES2 ON RES1.NameProd = RES2.NameProd and RES1.DAY = RES2.DAY \
    LEFT JOIN (" + this.getEXPProductSQL(starttime, endtime) + ") AS RES3 ON RES1.NameProd = RES3.NameProd and RES1.DAY = RES3.DAY WHERE RES1.NameProd != '' GROUP BY RES1.DAY,RES1.NameProd";
}*/
/*
CReports.prototype.generateEXPProductSQL = function(starttime, endtime) {
    return "SELECT RES3.NameProd, DelivQty,  ROUND(ExpirQty, 0) as ExpirQty, ROUND(SoldQty, 0) as SoldQty, RES3.VKPreis, RES3.VKEPreis, RES3.EKPreis, RES3.EKPreis/RES3.SoldQty as EKEPreis, RES3.GroupName, RES3.ProdId, RES3.DAY as DAY FROM (" +
    this.getEXPProductSQL(starttime, endtime) + ") AS RES1 LEFT JOIN (" +
    this.getDLVSQL(starttime, endtime) + ") AS RES2 ON RES1.NameProd = RES2.NameProd and RES1.DAY = RES2.DAY LEFT JOIN (" +
    this.getSLDProductSQL(starttime, endtime) + ") AS RES3 ON RES1.NameProd = RES3.NameProd and RES1.DAY = RES3.DAY WHERE RES1.NameProd != '' GROUP BY RES3.DAY,RES1.NameProd";
}*/
/*
CReports.prototype.generateSLDProductSQL = function(starttime, endtime) {

    return "SELECT RES1.NameProd, DelivQty,  ROUND(ExpirQty, 0) as ExpirQty, ROUND(SoldQty, 0) as SoldQty, RES1.VKPreis, RES1.VKEPreis, RES1.EKPreis, RES1.EKPreis/RES1.SoldQty as EKEPreis, RES1.GroupName, RES1.ProdId,RES1.DAY as DAY FROM (" +
        this.getSLDProductSQL(starttime, endtime) + ") AS RES1  \
    LEFT JOIN (" + this.getDLVSQL(starttime, endtime) + ") AS RES2 ON RES1.NameProd = RES2.NameProd and RES1.DAY = RES2.DAY \
    LEFT JOIN (" + this.getEXPProductSQL(starttime, endtime) + ") AS RES3 ON RES1.NameProd = RES3.NameProd and RES1.DAY = RES3.DAY WHERE RES1.NameProd != '' GROUP BY RES1.DAY,RES1.NameProd";
}*/

CReports.prototype.generateProductSQL = function(starttime, endtime) {
    return "SELECT Type,NameProd, ROUND(SUM(DelivQty),0) as DelivQty,  ROUND(SUM(ExpirQty), 0) as ExpirQty, ROUND(SUM(SoldQty), 0) as SoldQty, VKPreis, VKEPreis, EKPreis, EKPreis/SoldQty as EKEPreis, GroupName, ProdId,DAY  FROM  (" +
        this.getDLVSQL(starttime, endtime) + " UNION ALL " +
        this.getEXPProductSQL(starttime, endtime) + " UNION ALL " +
        this.getSLDProductSQL(starttime, endtime) + ") group by DAY,ProdId,VKEPreis";
}


CReports.prototype.getSLDProductSQL = function(starttime, endtime) {
    return "SELECT 'SLD' as Type,NameProd,0 as DelivQty,0 as ExpirQty, SUM(SoldQty) as SoldQty,SUM(VKPreis) as VKPreis,VKEPreis,SUM(EKPreis) as EKPreis,0 as EKEPreis,GroupName,ProdId,DAY from (" +
        "SELECT NameProd,SUM(SoldQty) as SoldQty,SUM(VKPreis) as VKPreis,VKEPreis,EKPreis,GroupName,ProdId,date(Time, 'unixepoch') as DAY from (" +
        this.getAlleProdukteSQL('SLD') + ")	where Time>=" + starttime + " AND Time<=" + endtime +
        " group by DAY,ProdId,VKEPreis UNION ALL	SELECT NameProd,SUM(SoldQty) as SoldQty,SUM(VKPreis) as VKPreis,VKEPreis,SUM(EKPreis) as EKPreis,GroupName,ProdId,date(Time, 'unixepoch')as DAY from (" +
        this.getProdukteInStrauessenSQL('SLD') + ") where Time>=" + starttime + " AND Time<=" + endtime + " and NameProd>'' group by DAY,ProdId,VKEPreis) group by DAY,ProdId,VKEPreis";
}




CReports.prototype.getEXPProductSQL = function(starttime, endtime) {
    return "SELECT 'EXP' as Type,NameProd,0 as DelivQty,ExpirQty, 0 as SoldQty, VKPreis, VKEPreis, 0 as EKPreis, 0 as EKEPreis, GroupName, ProdId,DAY from " +
        "(SELECT NameProd,SUM(ExpirQty) as ExpirQty,SUM(VKPreis) as VKPreis,VKEPreis,EKPreis,GroupName,ProdId,date(Time, 'unixepoch')as DAY from (" +
        this.getAlleProdukteSQL('EXP') + ") where Time>=" + starttime + " AND Time<=" + endtime +
        " group by DAY,ProdId,VKEPreis UNION ALL SELECT NameProd,SUM(ExpirQty) as ExpirQty,SUM(VKPreis) as VKPreis,VKEPreis,SUM(EKPreis) as EKPreis,GroupName,ProdId,date(Time, 'unixepoch')as DAY from (" +
        this.getProdukteInStrauessenSQL('EXP') + ") where Time>=" + starttime + " AND Time<=" + endtime + " group by DAY,ProdId,VKEPreis) group by DAY,ProdId,VKEPreis";
}



CReports.prototype.getDLVSQL = function(starttime, endtime) {
    return "SELECT 'DLV' as Type,BO1.Text1 as NameProd,SUM(BO1.Qty) as DelivQty,0	as ExpirQty, 0 as SoldQty, 0 as VKPreis, 0 as VKEPreis, 0 as EKPreis, 0 as EKEPreis, 0 as GroupName, IFNULL(BO1.Foreign_ID, '99999')as ProdId, \
    date(BO1.TS, 'unixepoch')as DAY FROM BONE as BO1 LEFT JOIN BON as BON1 ON BON1.BON_ID = BO1.BON_ID \
    where BON1.Type = 'DLV' AND BON1.Cancelled = 0 and BO1.Type = 'POS' and BO1.Cancelled = 0 \
    and (BO1.interaction IS NOT 'PDN') and BO1.TS>=" + starttime + "  AND BO1.TS <= " + endtime + " and BO1.Qty>0 " +
        " group by DAY,NameProd  "
}

CReports.prototype.generatexRBSQL = function(starttime, endtime) {
    return "SELECT 'xRB' as Type,case when StraussID>0 then Text else NameProd end as NameProd,0 as DelivQty,0	as ExpirQty,sum(case when StraussID>0  then QtyinBunch*SoldQty else SoldQty end) as SoldQty, \
    sum(case when StraussID>0 then (-1)*AmountinBunch*BONE3.Rebate-IFNULL(BONE6.RebateinBunch*AmountinBunch-(1-BONE6.RebateinBunch)*AmountinBunch*BONE3.Rebate,0) else Amount end) as VKPreis, 0 as VKEPreis, 0 as EKPreis, \
    0 as EKEPreis, 0 as GroupName, case when StraussID>1000000000 then BONE6.ProdID else BONE3.ProdID end as ProdId, date(BONE3.TS, 'unixepoch')as DAY \
    from \
(SELECT BONE.Text1 as NameProd,BONE.Qty as SoldQty, BONE2.Amount as Amount, BONE.Foreign_ID as ProdID, BONE2.Qty as Rebate,BONE.BON_ID as BON_ID, BONE.TS as TS, BONE.Type as Type , BONE2.Type as BONE2Type from BONE \
    left join BON on BON.BON_ID=BONE.BON_ID \
    left join BONE as BONE2 on BONE2.Reference_BONE_ID=BONE.BONE_ID \
    where BONE2.Type LIKE '%RB' and BON.cancelled=0 and BON.Type='CLS' and BONE.Cancelled=0 and BONE.Cancelled=0 and BONE2.Cancelled=0 and BONE.Type IS NOT 'GRB' and BONE.TS>=0) \
    as BONE3 \
    left join (select BONE.Foreign_ID as StraussID, BONE5.Foreign_ID as ProdID,BONE5.Text1 as Text,BONE5.Amount as AmountinBunch,BONE7.Qty as RebateinBunch,BONE5.Qty as QtyinBunch  from BONE \
    	left join BONE as BONE5 on BONE5.BON_ID=BONE.BON_ID \
    	left join BONE as BONE7 on BONE7.Reference_BONE_ID=BONE5.BONE_ID \
    where BONE.Foreign_ID>1000000000 and (BONE.Type='BFC' or BONE.Type='NPP') and BONE5.Cancelled=0 and BONE5.Type='POS')  \
    as BONE6 on BONE3.ProdID=BONE6.StraussID \
where BONE3.Type='POS' and TS>=" + starttime + "  AND TS <= " + endtime +
        " group by DAY,BONE3.ProdId"
}


CReports.prototype.generateGRBSQL = function(starttime, endtime) {

    return "SELECT 'GRB' as Type,case when BONE4.Qty>0 then BONE4.Text1 else BONE2.Text1 end as NameProd, 0 as DelivQty,0 as ExpirQty,SUM(case when BONE4.Qty>0 then BONE4.Qty*BONE2.Qty else BONE2.Qty end) as SoldQty,\
        round(SUM(case when BONE4.Qty>0 then (-1)*BONE4.Amount*BONE2.Qty*BONE.Qty else (-1)*BONE2.Amount*BONE.Qty end),2) as VKPreis, 0 as VKEPreis, 0 as EKPreis, 0 as EKEPreis, 0 as GroupName, case when BONE2.Foreign_ID<1000000000 \
        then BONE2.Foreign_ID else BONE4.Foreign_ID end as ProdId, \
        date(BONE.TS, 'unixepoch')as DAY  from BONE \
    left join BON on BON.BON_ID=BONE.BON_ID \
    left join  BONE as BONE2 on BONE.BON_ID=BONE2.BON_ID and BONE2.Cancelled=0 \
    left join (select BON_ID,Foreign_ID from BONE where Foreign_ID>1000000000 and (Type='BFC' or Type='NPP')) as BONE3 on BONE2.Foreign_ID= BONE3.Foreign_ID \
    left join (select Text1,Qty,Amount,BON_ID,Cancelled,Foreign_ID from BONE where Type='POS' and Cancelled=0) as BONE4 on BONE4.BON_ID=BONE3.BON_ID \
  where  BONE.Type IS 'GRB' and BON.cancelled=0 and BONE.Cancelled=0 and BONE.Cancelled=0 and BON.Type='CLS'and BONE2.Type='POS' and BONE.TS>=" + starttime + "  AND BONE.TS <= " + endtime +
        " group by DAY,ProdId  "
}


CReports.prototype.getAlleProdukteSQL = function(arg) {

    if (arg == 'EXP') {
        var qtyfield = 'ExpirQty';
        var type = 'EXP';
    } else if (arg == 'DLV') {
        qtyfield = 'DelivQty';
        type = 'DLV';
    } else {
        qtyfield = 'SoldQty';
        type = 'CLS';
    }

    return "SELECT NameProd,\
    SUM(Qty) AS " + qtyfield + "," +
        "SUM(Amount) AS VKPreis,UnitAmount AS VKEPreis,SUM(Wholesale) AS EKPreis,GroupName, ProdId, Time  FROM (SELECT BO1.Text1 as NameProd,\
      BO1.Qty as Qty,BO1.Amount as Amount,BO1.Amount_Unit as UnitAmount,BO1.WholesaleAmount as Wholesale,IFNULL((B2.Text1 || B2.text2), '-') as GroupName,\
      BO1.Foreign_ID as ProdId, BO1.TS as Time \
      FROM BONE as BO1 \
      LEFT JOIN BON as BON1 ON BON1.BON_ID = BO1.BON_ID \
      LEFT JOIN BTN as B1 ON B1.PROD_ID = BO1.Foreign_ID \
      LEFT JOIN BTN as B2 ON B2.BTN_ID = B1.Parent_BTN_ID \
      LEFT JOIN PROD as B3 ON B3.PROD_ID = Foreign_ID \
      where(NOT(Foreign_ID>=1000000000) OR (Foreign_ID>1000000000 AND B3.Type IS NOT 'BFF')) \
      and BON1.Type = '" + type + "' AND BON1.Cancelled = 0 and BO1.Type = 'POS' and BO1.Cancelled = 0 \
      and (BO1.interaction IS NOT 'PDN') order by NameProd) \
      group by ProdId,VKEPreis,Time";

}

/*SELECT NameProd,    SUM(Qty)AS SoldQty,SUM(Amount)AS VKPreis,UnitAmount AS VKEPreis,SUM(Wholesale)AS EKPreis,GroupName, ProdId, Time  FROM
                (SELECT BO1.Text1 as NameProd,      BO1.Qty as Qty,BO1.Amount as Amount,BO1.Amount_Unit as UnitAmount,BO1.WholesaleAmount as Wholesale,IFNULL((B2.Text1 || B2.text2), '-')as GroupName,
                        IFNULL(B1.PROD_ID, '99999')as ProdId, BO1.TS as Time       FROM BONE as BO1
                          LEFT JOIN BON as BON1 ON BON1.BON_ID = BO1.BON_ID
                          LEFT JOIN BTN as B1 ON B1.PROD_ID = BO1.Foreign_ID
                          LEFT JOIN BTN as B2 ON B2.BTN_ID = B1.Parent_BTN_ID
                          LEFT JOIN PROD as B3 ON B3.PROD_ID = Foreign_ID
                          where(NOT(Foreign_ID>=1000000000)OR(Foreign_ID>1000000000 AND B3.Type IS NOT 'BFF'))       and BON1.Type = 'CLS' AND BON1.Cancelled = 0 and BO1.Type = 'POS' and BO1.Cancelled = 0
                          and (BO1.interaction IS NOT 'PDN') order by NameProd)
              group by NameProd,Time*/

CReports.prototype.getProdukteInStrauessenListSQL = function() {
    return "SELECT IFNULL(BO1.Text1, '-') as NameProd,\
    BO1.Qty as Qty,\
    BO1.Amount as Amount,\
    BO1.Amount_Unit as UnitAmount,\
    PS.WholesaleAmount as Wholesale,\
    IFNULL(BO1.Foreign_ID, '99999') as ProdId,\
    IFNULL(BO2.Text1, '-') as StraussName,\
    BO2.Qty as StraussQty,\
    BO2.Amount as StraussAmount,\
    BO2.Amount_Unit as StraussUnitAmount,\
    BO2.WholesaleAmount as StraussWholesale,\
    IFNULL(BO2.Foreign_ID, '99999') as StraussForeign_ID,\
    IFNULL((BUT2.Text1 || BUT2.text2), '-') as GroupName \
    FROM BONE as BO1 \
    LEFT JOIN BONE as BO2 ON BO1.BON_ID = BO2.BON_ID \
    LEFT JOIN PRODSTOCK as PS ON PS.PROD_ID = BO1.Foreign_ID \
    LEFT JOIN BTN as BUT1 ON BUT1.PROD_ID = BO1.Foreign_ID \
    LEFT JOIN BTN as BUT2 ON BUT2.BTN_ID = BUT1.Parent_BTN_ID \
    where BO1.Type = 'POS' AND BO1.Cancelled = 0 AND BO2.Type = 'BFC'";

}


CReports.prototype.getProdukteInStrauessenSQL = function(arg) {
    if (arg == 'EXP') {
        var qtyfield = 'ExpirQty';
        var type = 'EXP';
    } else if (arg == 'DLV') {
        qtyfield = 'DelivQty';
        type = 'DLV';
    } else {
        qtyfield = 'SoldQty';
        type = 'CLS';
    }

    return "SELECT NameProd,\
    SUM(Strausse.Qty * B1.Qty)as " + qtyfield + "," +
        "(SUM(Strausse.Qty * B1.Qty) * Strausse.UnitAmount)as VKPreis,\
        Strausse.UnitAmount as VKEPreis,\
        Strausse.Wholesale as EKPreis,\
        GroupName,\
        ProdId,\
        StraussForeign_ID,\
        B1.TS as Time \
        FROM BONE as B1 \
        LEFT JOIN BON as BON1 ON BON1.BON_ID = B1.BON_ID \
        LEFT JOIN(" + this.getProdukteInStrauessenListSQL() + ") \
        as Strausse ON StraussForeign_ID=B1.Foreign_ID \
        where(B1.Foreign_ID>=1000000000) \
        and BON1.Type = '" + type + "' AND BON1.Cancelled = 0  and B1.Cancelled = 0 \
        and NameProd IS NOT NULL group by ProdId,VKEPreis,Time";
}




CReports.prototype.getBunchesSQL = function(starttime, endtime) {
    //SELECT RES1.NameProd, DelivQty,  ROUND(ExpirQty, 0) as ExpirQty, ROUND(SoldQty, 0) as SoldQty,
    //RES1.VKPreis, RES1.VKEPreis, RES1.EKPreis, RES1.EKPreis/RES1.SoldQty as EKEPreis, RES1.GroupName, RES1.ProdId
    return "SELECT 'BNC' as Type,RES1.NameProd as NameProd, 0 as DelivQty, ROUND(ExpirQty, 0) as ExpirQty, ROUND(SoldQty, 0) as SoldQty,\
    VKPreis, VKEPreis, EKPreis, EKPreis/SoldQty as EKEPreis, '-' as GroupName, '-' as ProdId,RES1.DAY as DAY FROM \
    (SELECT \
      IFNULL(BO1.Text1, '-') as NameProd,\
      SUM(BO1.Qty) as SoldQty,\
      ROUND(SUM(BO1.Amount),2) as VKPreis,\
      ROUND(AVG(BO1.Amount_Unit),2) as VKEPreis,\
      AVG(BO1.WholesaleAmount) as EKPreis,\
      date(TS, 'unixepoch')as DAY \
      FROM BONE as BO1 \
      LEFT JOIN BON as BON1 ON BO1.BON_ID=BON1.BON_ID \
      LEFT JOIN PROD as P ON BO1.Foreign_ID=P.PROD_ID \
      where BO1.Type = 'POS' AND BO1.Cancelled = 0 and \
      BON1.Cancelled = 0 and  BON1.Type = 'CLS' and \
      (BO1.Foreign_ID>=1000000000) AND P.Type IS  'BFF' \
      and BO1.TS >= " + starttime + " AND BO1.TS <= " + endtime +
        " GROUP BY DAY,NameProd)\
        AS RES1 LEFT JOIN \
        (SELECT \
          SUM(Qty) AS ExpirQty,\
          IFNULL(Text1, '-') as NameProd,date(TS, 'unixepoch')as DAY  \
          FROM BON inner join BONE on  BON.BON_ID = BONE.BON_ID \
          WHERE BON.Type = 'EXP' AND BON.Cancelled = 0 AND BONE.Cancelled = 0 \
          and TS >= " + starttime + " AND TS <= " + endtime +
        " GROUP BY DAY,NameProd) \
        AS RES3 ON RES1.NameProd = RES3.NameProd and RES1.DAY = RES3.DAY\
        ORDER BY RES1.DAY,RES1.NameProd DESC"

}


CReports.prototype.generateRPRSQL = function(starttime, endtime) {
    return "SELECT 'RPR' as Type,'-' as NameProd, 0 as DelivQty, 0 as ExpirQty, 0 as SoldQty,\
    total as VKPreis, 0 as VKEPreis, 0 as EKPreis, 0 as EKEPreis, '-' as GroupName, '-' as ProdId,DAY from \
    (SELECT Round(SUM(BONE.Amount),2) as total,  date(BONE.TS, 'unixepoch')as DAY \
    FROM BONE inner join BON on BON.BON_ID = BONE.BON_ID \
    where BONE.Type = 'POS' and BON.Type = 'CLS' and BON.Cancelled = 0 and BONE.Cancelled = 0 AND \
    BONE.TS >= " + starttime + " AND BONE.TS <= " + endtime + " group by DAY) group by DAY"
}

//module.exports = CReports;

export { CReports };
